import * as React from 'react';
import uuid from 'uuid';
import Icon from 'antd/lib/icon';
import Tooltip from 'antd/lib/tooltip';
import Select from 'antd/lib/select';
import InputNumber from 'antd/lib/input-number';
import Loader from 'src/components/common/Loader';
import AccessIcon from './create-shipment.svg/access';
import withStyles from 'react-jss';
import PortIcon from './create-shipment.svg/port';
import TagsInput from 'src/components/common/TagsInput';
import PrimaryIcon from './create-shipment.svg/primary';
import ContentsIcon from './create-shipment.svg/contents';
import ContainerIcon from './create-shipment.svg/container';
import SelectCargo from 'src/components/common/CommonSelect/SelectCargo';
import SelectProductType from 'src/components/common/CommonSelect/SelectProductType';
import SelectProducts from 'src/components/common/CommonSelect/SelectProducts';
import SelectTeam from 'src/components/common/CommonSelect/SelectTeam';
import SelectPort from 'src/components/common/CommonSelect/SelectPort';
import SelectMode from 'src/components/common/CommonSelect/SelectMode';
import SelectCountry from 'src/components/common/CommonSelect/SelectCountry';
import SelectAccess from 'src/components/common/CommonSelect/SelectAccess';
import SelectIncoterm from 'src/components/common/CommonSelect/SelectIncoterm';
import SelectShippingLine from 'src/components/common/CommonSelect/SelectShippingLine';
import { newShipmentFirstStyles } from './new-shipment.styles';
import { ShipmentFormFields, ShipmentFormFieldsDomestic, formItemLayout, ProductFormFieldExtraKeys, ContainerFormFieldExtraKeys } from './new-shipment.constants';
import { AccessType, ModesOfService, StakeholderTypes, CargoOperationType } from 'src/Library/Constants';
import { isBreakBulkMode } from '../SE.constants';
import { prettifyString, validateEmail } from 'src/utils/utils';
import { formRules } from 'src/Library/Helper';
import { MOVEMENT_TYPES } from '../../Container/ContainerUtils';
import { PortTypes } from 'src/Library/Types';
import { NewShipmentFirstProps, FormField, Container, Product, ContainerField, fieldConfig } from './new-shipment.types';
import { Checkbox, Input, message, Radio, Form } from 'antd';
import { MovementTypes } from '../../Container/UnifiedShipmentView/CreateShipment.helper';
import { useReduxState } from 'src/hooks/useRedux';
import GenericHoc from 'src/components/hoc/GenericHoc';
import { HocOptions } from 'src/components/hoc/GenericHoc.types';
import { searchTeam } from 'src/api/teams';
import { searchStakeholder } from 'src/api/masters';
import { EXCLUDED_WEIGHT_UNITS } from '../../Enquiry/constants';
import SelectAddress from 'src/components/common/CommonSelect/SelectAddress';

const FormItem = Form.Item;
const NewShipmentFirst = (props: NewShipmentFirstProps) => {

  const {
    classes,
    form,
    editData,
    executionMaster,
    productsList,
    containerList,
    setProducts,
    loading,
    setContainers,
    formFieldConfig,
    hide,
    isBlNumberPresent,
    isFieldDiabled,
    isConfigLoading,
    disableBooking,
    domesticVehicleTypeSizeList,
    disableGrossWeightCalculation,
    showRoadinsteadOfDomestic,
    stakeholderAccountType
  } = props;

  const { getFieldDecorator } = form;

  const [originWetPortVisible, setOriginWetPortVisible] = React.useState<boolean>(false);
  const [destinationWetPortVisible, setDestinationWetPortVisible] = React.useState<boolean>(false);
  const [originLocation, setOriginLocation] = React.useState<any>(undefined);
  const [destinationLocation, setDestinationLocation] = React.useState<any>(undefined);
  const [temperatureField, setTemperatureField] = React.useState<ContainerField>();
  const [newDimension, setNewDimension] = React.useState<{
    item?: Container,
    toggle: boolean,
  }>({ toggle: false });

  const [packageDetailsToShow, setPackageDetailsToShow] = React.useState<(ContainerField | undefined)[]>([]);
  const [selectedContainerType, setSelectedContainerType] = React.useState<any>('');
  const [teamOptions, setTeamOptions] = React.useState<any[]>([]);
  const [supplierShippers, setSupplierShippers] = React.useState<any[]>([]);


  const {
    POL,
    POD,
    MODE,
    TEAM,
    BLNUMBER,
    CARGO,
    ACCESS,
    WATCHER,
    CARRIER,
    PRODUCT,
    CONTAINER,
    SUB_CARGO,
    STACKABLE,
    INCOTERM,
    MOVEMENT,
    ORIGIN_PORT,
    DESTINATION_PORT,
    ORIGIN_COUNTRY,
    DESTINATION_COUNTRY,
    ORIGIN_SERVICE,
    DESTINATION_SERVICE,
    LOADINGLOCATION,
    UNLOADINGLOCATION,
    ORIGIN_ADDRESS,
    DESTINATION_ADDRESS,
  } = ShipmentFormFields;

  const {
    mode,
    type,
    cargoType,
    validWeightUnits,
    validVolumeUnits,
    validDimensionUnits,
    validOtherUnits,
    validContainerTypes,
    validContainerSizes,
    validCargoTypeToCargoSubtypeMapping,
    shippingModeToValidIncotermMapping,
    validContainerOrPackageTypesBasedOnMode,
    validContainerTypesForCargoFCL,
    allowSkuNumber,
    allowCases,
    organisationId
  } = executionMaster;
  

  function setInitial() {
    form.setFieldsValue({
      mode: editData?.mode || ModesOfService.FCL,
      accessType: editData?.accessType || { key: AccessType.PUBLIC },
      originPortCode: editData?.originPortCode,
      originCountryCode: editData?.originCountryCode,
      destinationCountryCode: editData?.destinationCountryCode,
      destinationPortCode: editData?.destinationPortCode,
      blNumber: editData?.blNumber,
      incoterm: editData?.incoterm,
    });
  }

  const modeOfService = form.getFieldValue(MODE.key);
  const movementType: keyof typeof MovementTypes = form.getFieldValue(MOVEMENT.key);
  const accessType = form.getFieldValue(ACCESS.key);
  const cargoTypeValue = form.getFieldValue(CARGO.key);
  const originPortValue = form.getFieldValue(ORIGIN_PORT.key);
  const originLocationId = form.getFieldValue(LOADINGLOCATION.key);
  const originCountry = form.getFieldValue(ORIGIN_COUNTRY.key);
  const destinationPortValue = form.getFieldValue(DESTINATION_PORT.key);
  const destinationLocationId = form.getFieldValue(UNLOADINGLOCATION.key);
  const destinationCountry = form.getFieldValue(DESTINATION_COUNTRY.key);
  const blNumberValue = form.getFieldValue(BLNUMBER.key);
  const incotermValue = form.getFieldValue(INCOTERM.key);
  const isRoadBased = modeOfService === ModesOfService.DOMESTIC || modeOfService === ModesOfService.RPTL;
  // Break Bulk mirrors LCL: when master data has no Break Bulk key, resolve master-data lookups against LCL.
  const lookupMode = isBreakBulkMode(modeOfService) ? ModesOfService.LCL : modeOfService;

  React.useEffect(() => {
    setInitial();
    setPackageDetailsToShow(modeToContainerMapping(ModesOfService.FCL));
  }, []);

  React.useEffect(() => {
    const fieldsList = modeToContainerMapping(modeOfService || editData?.mode);
    setPackageDetailsToShow(fieldsList);
  }, [modeOfService, editData?.mode, incotermValue, blNumberValue, selectedContainerType, isConfigLoading]);

  React.useEffect(() => {
    const fetchSupplierShippers = async () => {
      if (props.stakeholderAccountType === StakeholderTypes.CUSTOMER) {
        const response = await searchStakeholder({ type: StakeholderTypes.SUPPLIER, queryString: '' });
        if (response && Array.isArray(response.data)) {
          setSupplierShippers(response.data);
        } else {
          setSupplierShippers([]);
        }
      }
    };
    fetchSupplierShippers();
  }, [props.stakeholderAccountType]);
  // ... existing code ...

  const modeToContainerMapping = (mode: ModesOfService) => {
    switch (mode) {
      case ModesOfService.LCL:
      case ModesOfService.RPTL:
      case ModesOfService.BREAK_BULK:
        return [
          ContainerFields.containerType,
          ContainerFields.containerCount,
          ContainerFields.packageLength,
          ContainerFields.packageBreadth,
          ContainerFields.packageHeight,
          ContainerFields.containerDimensionUnit,
          ContainerFields.packageMinVolume,
          ContainerFields.containerMinVolumeUnit,
          ContainerFields.grossWeight,
          ContainerFields.containerWeightUnit,
          ContainerFields.totalGrossWt,
        ];
      case ModesOfService.AIRCARGO:
        return [
          ContainerFields.containerType,
          ContainerFields.containerCount,
          ContainerFields.packageLength,
          ContainerFields.packageBreadth,
          ContainerFields.packageHeight,
          ContainerFields.containerDimensionUnit,
          ContainerFields.grossWeight,
          ContainerFields.containerWeightUnit,
          ContainerFields.totalGrossWt,
          ContainerFields.totalVolumetricWt,
        ];
      default:
        return [
          ContainerFields.containerType,
          ContainerFields.containerSize,
          temperatureField || showTemperature(),
          ContainerFields.containerCount,
          ContainerFields.containerWeight,
          ContainerFields.containerWeightUnit,
        ];
    }
  }

  // const isBlNumberPresent = Boolean(
  //   (form.getFieldValue(BLNUMBER.key) || editData.blNumber)
  //   && modeOfService === ModesOfService.FCL
  //   && movementType === MOVEMENT_TYPES.IMPORT
  // );

  // https://en.wikipedia.org/wiki/Dimensional_weight
  const VOLUMETRIC_WT_DENOMINATOR = 6000; // ToDo: This must be coming from backend

    const volumeConverterMap = useReduxState(['inquiryReducer', 'masterData', 'volumeConverterMap'])
      .value;
    const allowSamePolPod = useReduxState(['inquiryReducer', 'masterData', 'allowSamePolPod'])
      .value;
  
    React.useEffect(() => {
      if (!originPortValue || !destinationPortValue) {
        return;
      }

        if (!allowSamePolPod && originPortValue.code === destinationPortValue.code) {
          message.error('Origin and Destination Port cannot be same');
          return;
        }
      }, [originPortValue, destinationPortValue, allowSamePolPod]);

  React.useEffect(() => {
    if (!originLocationId?.key || !destinationLocationId?.key) {
      return;
    }
    if (originLocationId.key === destinationLocationId.key) {
      message.error('Origin and destination location cannot be same');
      return;
    }
  }, [originLocationId, destinationLocationId]);
  
  const getLabel = (label: string | React.ReactElement, required = false) => {
    return (
      <span className={classes.ellipses}>
        <Tooltip title={label} className={classes.labelEllipsis}>{label}</Tooltip>
        {!isBlNumberPresent && required && <span className={classes.required}>*</span>}
      </span>
    );
  };

  const getCountryInitialValue = (field: FormField) => {
    if (!editData?.id) {
      return undefined;
    }
    switch (field.key) {
      case ORIGIN_COUNTRY.key: return editData?.originCountryCode;
      case DESTINATION_COUNTRY.key: return editData?.destinationCountryCode;
      default: return undefined;
    };
  };

  const countryDisabled = (field: FormField) => {
    if (isFieldDiabled(field?.disableKey)) {
      return true;
    }
    if (field.key === ORIGIN_COUNTRY.key) {
      return Boolean(
        (originPortValue?.countryCode && originPortValue?.type === PortTypes.WET)
        || (originCountry?.key && originLocationId?.key)
      );
    }
    return Boolean(
      (destinationPortValue?.countryCode && destinationPortValue?.type === PortTypes.WET)
      || (destinationCountry?.key && destinationLocationId?.key)
    );
  };

  const renderCountry = (field: FormField) => {
    const isRequired = formFieldConfig[field.configKey] ?? field.required;
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={getLabel(field.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(field.key, {
        initialValue: getCountryInitialValue(field),
        rules: !isBlNumberPresent ? [rules] : undefined,
      })(<SelectCountry
        placeholder={field.placeholder}
        className={classes.input}
        disabled={countryDisabled(field)}
        isExecution={true}
      />)}
    </FormItem>;
  };

  const renderPrimaryTitle = () => {
    return <div className={classes.boxTitle}>
      <div className={classes.boxIcon}>
        <PrimaryIcon className={classes.boxIcon} />
      </div>
      <span>Primary Details</span>
    </div>;
  };

  const handleOnChangeMode = (value) => {
    const values: any = {};
    const packagingDetails = form.getFieldsValue().packagingDetails;

    Object.keys(packagingDetails || {}).forEach((key, idx) => {
      Object.keys(packagingDetails[key] || {}).forEach((item) => {
        values[`${ShipmentFormFields.CONTAINER.key}[${key}]['${item}']`] = undefined;
      });
    });
    form.setFieldsValue(values);

  };

  const renderMode = () => {
    return <FormItem
      label={getLabel(MODE.label, MODE.required)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(MODE.key, {
        initialValue: editData?.id ? editData[MODE.key] : ModesOfService.FCL,
        rules: !isBlNumberPresent ? [formRules.required] : undefined,
      })(<SelectMode
        placeholder={MODE.placeholder}
        className={classes.input}
        allowedMode={mode}
        showRoadinsteadOfDomestic={showRoadinsteadOfDomestic}
        disabled={editData?.modeDisabled}
        onChange={(value) => {
          handleOnChangeMode(value);
        }}
        />)}
    </FormItem>;
  };

  const renderIncoterm = () => {
    if (isRoadBased) return null;
    return <FormItem
      label={getLabel(INCOTERM.label, INCOTERM.required)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(INCOTERM.key, {
        initialValue: editData?.id ? editData[INCOTERM.key] : undefined,
        rules: !isBlNumberPresent ? [formRules.required] : undefined,
      })(<SelectIncoterm
        placeholder={INCOTERM.placeholder}
        className={classes.input}
        disabled={editData?.incotermDisabled}
        allowedIncoterm={lookupMode ?
          shippingModeToValidIncotermMapping[lookupMode] :
          shippingModeToValidIncotermMapping.FCL
        }
      />)}
    </FormItem>;
  };

  const renderCarrier = () => {
    const mode = form.getFieldValue(MODE.key) || editData[MODE.key];
    if (isRoadBased) return null;
    const isRequired = formFieldConfig[CARRIER.configKey] ?? CARRIER.required;
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={getLabel(CARRIER.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(CARRIER.key, {
        initialValue: editData?.id ? editData?.carrierCode : undefined,
        rules: !isBlNumberPresent ? [rules] : undefined,
      })(<SelectShippingLine
        type={mode}
        placeholder={CARRIER.placeholder}
        className={classes.input}
        disabled={editData?.carrierDisabled}
        allowedIncoterm={shippingModeToValidIncotermMapping[lookupMode]}
      />)}
    </FormItem>;
  };

    const renderSupplierShipper = () => {
    if (stakeholderAccountType !== StakeholderTypes.CUSTOMER) return null;
    return <FormItem
      label={getLabel('Supplier/Shipper', true)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator('shipperId', {
        initialValue: supplierShippers[0]?.org2Id,
        rules: [formRules.required],
      })(<Select 
        disabled={true}
      >
        {supplierShippers.map(shipper => (
          <Select.Option key={shipper.org2Id} value={shipper.org2Id}>
            {shipper.name}
          </Select.Option>
        ))}
      </Select>)}
    </FormItem>;
  };

  const renderType = () => {
    return <FormItem
      label={getLabel(MOVEMENT.label, MOVEMENT.required)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(MOVEMENT.key, {
        rules: !isBlNumberPresent ? [formRules.required] : undefined,
        initialValue: editData?.id ? editData[MOVEMENT.key] : MOVEMENT_TYPES.EXPORT,
      })(<Select
        placeholder={MOVEMENT.placeholder}
        className={classes.input}
        disabled={modeOfService === ModesOfService.DOMESTIC || editData?.movementTypeDisabled}
      >
        {Object.keys(type).map(key => <Select.Option key={key}>
          {type[key]}
        </Select.Option>)}
      </Select>)}
    </FormItem>;
  };

  const renderBlNumber = () => {
    if (modeOfService !== ModesOfService.FCL || movementType !== MOVEMENT_TYPES.IMPORT) {
      return null;
    }
    const isRequired = formFieldConfig[BLNUMBER.configKey] ?? BLNUMBER.required;
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={getLabel(BLNUMBER.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(BLNUMBER.key, {
        initialValue: editData?.id ? editData?.blNumber : undefined,
        rules: [rules]
      })(<Input
        placeholder={BLNUMBER.placeholder}
        className={classes.input}
        disabled={editData?.blNumberDisabled}
      />)}
    </FormItem>;
  }

  const renderPrimaryDetails = () => {
    const { stakeholderAccountType } = props;
    const isCustomer = stakeholderAccountType === StakeholderTypes.CUSTOMER;
    return <div className={classes.boxFields}>
      <div className={classes.flexRow}>
        {renderMode()}
        {renderIncoterm()}
      </div>
      <div className={classes.flexRow}>
        {renderType()}
        {renderCarrier()}
      </div>
      <div className={classes.flexRow}>
        {isCustomer && renderSupplierShipper()}
        {renderBlNumber()}
      </div>
    </div>;
  };

  const renderPrimary = () => {
    return <div className={classes.box}>
      {renderPrimaryTitle()}
      {renderPrimaryDetails()}
    </div>;
  };

  const renderPortTitle = () => {
    return <div className={classes.boxTitle}>
      <div className={classes.boxIcon}>
        <PortIcon className={classes.boxIcon} />
      </div>
      <span>Locations</span>
    </div>;
  };

  const handlePortChange = (port: Ports, field: FormField) => {
    if (!port?.code) {
      return;
    }
    const value = {
      key: port.countryCode,
      label: port.countryName,
    };
    form.setFieldsValue({
      [field.countryKey as string]: value,
    });
  };

  const airPortOptions = {
    type: ['AIR'],
  };
  
  const portOptions = {
    type: ['DRY', 'WET'],
  };

  const dryPortOptions = {
    type: ['WET'],
  };

  const getPortInitialValue = (field: FormField) => {
    if (!editData.id) {
      return undefined;
    }
    return editData[field.key];  
  };

  const renderPortInput = (field: FormField, options) => {
    if (isRoadBased) return null;
    const isRequired = formFieldConfig[field.configKey] ?? field.required;
    const rules = {...formRules.required};
    rules.required = isRequired;
    const prefill = getPortInitialValue(field);
    return <FormItem
      label={getLabel(field.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(field.key, {
        initialValue: prefill,
        rules: !isBlNumberPresent ? [rules] : undefined,
      })(<SelectPort
        value={prefill}
        disabled={isFieldDiabled(field.disableKey)}
        apiOptions={options}
        onChange={(port: Ports) => handlePortChange(port, field)}
        className={classes.input}
        placeholder={field.placeholder}
      />)}
    </FormItem>;
  };

  const handleLocationChange = (value, option, field: FormField) => {
    form.setFieldsValue({
      [field.key]: value,
    });
    if (field.key === ShipmentFormFieldsDomestic.LOADINGLOCATION.key) {
      setOriginLocation(option?.props);
      form.setFieldsValue({
        originCountryCode: {
          key: option?.props?.countryCode,
          label: option?.props?.countryName,
        }
      });
    } else {
      setDestinationLocation(option?.props);
      form.setFieldsValue({
        destinationCountryCode: {
          key: option?.props?.countryCode,
          label: option?.props?.countryName,
        }
      });
    }
  };

  const renderLocation = (field: FormField) => {
    if (!isRoadBased) return null;
    const key = field.key === ShipmentFormFieldsDomestic.UNLOADINGLOCATION.key 
      ? 'deStuffingLocation' 
      : 'stuffingLocation';
    const addressType = field.key === ShipmentFormFieldsDomestic.UNLOADINGLOCATION.key
      ? CargoOperationType.DESTUFFING
      : CargoOperationType.STUFFING;

    const isRequired = isRoadBased;
    const rules = {...formRules.required};
    rules.required = isRequired

    const isCustomer = stakeholderAccountType === StakeholderTypes.CUSTOMER;
    const shipperId = isCustomer ? form.getFieldValue('shipperId') : undefined;

    const selectedAddress = field.key === ShipmentFormFieldsDomestic.LOADINGLOCATION.key 
      ? originLocation 
      : destinationLocation;
    const displayAddress = selectedAddress?.displayAddress;

    const addressKey = field.key === ShipmentFormFieldsDomestic.LOADINGLOCATION.key 
    ? ORIGIN_ADDRESS.key : DESTINATION_ADDRESS.key;

    return <FormItem
      label={getLabel(field.label, isRequired)}
      className={`${classes.formItem} ${classes.locationFormItem}`}
      {...formItemLayout}
    >
      {getFieldDecorator(field.key, { initialValue: editData?.[field.key] })(<Input hidden={true} />)}
      <div className={classes.locationDropdownWrapper}>
        {getFieldDecorator(field.key, 
        {
          initialValue: editData?.[field.key],
          rules: [rules]
        })(<SelectAddress
          placeholder={field.placeholder}
          className={classes.input}
          cargoOperationType={addressType}
          shipperId={shipperId}
          labelInValue={true}
          onChange={(value, option) => handleLocationChange(value, option, field)}
        />
        )}
        <div className={classes.locationAddressDisplay}>
          {displayAddress || editData[addressKey]}
        </div>
      </div>
    </FormItem>;
  };

  async function searchTeams() {
    const response = await searchTeam({ teamId: editData.teamIds });
    if (response.isSuccess) {
        setTeamOptions(response.data.map(el => ({ key: el.id, label: el.name })));
    } else message.error(response.errorMessage);
  }

  React.useEffect(() => {
    if (editData?.teamDetails){
      setTeamOptions(editData.teamDetails.map(el => ({ key: el.teamId, label: el.teamName })));
      return;
    }
    searchTeams();
  }, []);


  React.useEffect(() => {
    if (originPortValue?.type === 'DRY') {
      setOriginWetPortVisible(true);
      return;
    } 
    setOriginWetPortVisible(false);
  }, [originPortValue]);

  React.useEffect(() => {
    if (destinationPortValue?.type === 'DRY') {
      setDestinationWetPortVisible(true);
      return;
    } 
    setDestinationWetPortVisible(false);
  }, [destinationPortValue]);

  const renderPol = () => {
    if (!originWetPortVisible) {
      return <div style={{ width: '50%' }} />;
    }
    return renderPortInput(POL, dryPortOptions);
  };

  const renderPod = () => {
    if (!destinationWetPortVisible) return null;
    return renderPortInput(POD, dryPortOptions);
  };

  const renderPortFields = () => {
    const portOptionsForMode = modeOfService === ModesOfService.AIRCARGO ? airPortOptions : portOptions;
    return <div className={classes.boxFields}>
      <div className={classes.flexRow}>
        {renderPortInput(ORIGIN_PORT, portOptionsForMode)}
        {renderPortInput(DESTINATION_PORT, portOptionsForMode)}
        {renderLocation(ShipmentFormFieldsDomestic.LOADINGLOCATION)}
        {renderLocation(ShipmentFormFieldsDomestic.UNLOADINGLOCATION)}
      </div>
      <div className={classes.flexRow}>
        {renderPol()}
        {renderPod()}
      </div>
      <div className={classes.flexRow}>
        {renderCountry(ORIGIN_COUNTRY)}
        {renderCountry(DESTINATION_COUNTRY)}
      </div>
    </div>;
  };

  const renderPort = () => {
    return <div className={classes.box}>
      {renderPortTitle()}
      {renderPortFields()}
    </div>;
  };

  const renderAccessTitle = () => {
    return <div className={classes.boxTitle}>
      <div className={classes.boxIcon}>
        <AccessIcon className={classes.boxIcon} />
      </div>
      <span>Access</span>
    </div>;
  };

  const renderAccessType = () => {
    const isCustomer = stakeholderAccountType === StakeholderTypes.CUSTOMER;
    const defaultAccess = isCustomer ? AccessType.PUBLIC : undefined;
    return <FormItem
      label={getLabel(ACCESS.label, ACCESS.required)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(ACCESS.key, {
        rules: !isBlNumberPresent ? [formRules.required] : undefined,
        initialValue: editData?.accessType || { key: defaultAccess },
      })(<SelectAccess
        placeholder={ACCESS.placeholder}
        className={classes.input}
        organisationId={organisationId}
        visibleAccessTypes={isCustomer ? ['TEAM', 'PUBLIC'] : undefined}
      />)}
    </FormItem>;
  };

  const renderTeamField = () => {
    if (
      accessType?.key !== 'TEAM'
    ) return null;
    let initialValue;
    const isCustomer = stakeholderAccountType === StakeholderTypes.CUSTOMER;
    if (typeof editData.teamIds === 'string'){
      const data = editData?.teamIds ? editData.teamIds.split(',') : [];
      const matchingRecord = data ? teamOptions.find(option => option.label === data[0]) : null;
      if (matchingRecord){
        initialValue = [matchingRecord]
      } else {
        initialValue = teamOptions
      }
    }
    else {
      initialValue = editData.teamIds
    }
    return <FormItem
      label={getLabel(TEAM.label, TEAM.required)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(TEAM.key, {
        rules: !isBlNumberPresent ? [formRules.required] : undefined,
        initialValue: initialValue,
      })(<SelectTeam
        placeholder={TEAM.placeholder}
        className={classes.input}
        isStakeholder={isCustomer}
        mode="multiple"
      />)}
    </FormItem>;
  };

  const renderWatcherLabel = <span className={classes.flexRow}>
    <span>{WATCHER.label}</span>
    <Tooltip
      title="Add e-mail IDs of users to let them get updates for this task">
      <Icon
        style={{ marginLeft: 4 }}
        type="question-circle"
        theme="filled"
      />
    </Tooltip>
  </span>;

  function validateWatchers(emails: string[], callback: Function) {
    const wrongEmail = emails.some((email: string) => !validateEmail(email));
    if (wrongEmail) {
      return callback('Incorrect e-mails present');
    }
    return callback();
  }

  const renderWatchers = () => {
    return <FormItem
      label={getLabel(renderWatcherLabel)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(WATCHER.key, {
        rules: [{
          validator: (rule, value, callback) => validateWatchers(value, callback),
        }],
        initialValue: editData?.watcherList,
      })(<TagsInput
        placeholder={WATCHER.placeholder}
        className={classes.input}
      />)}
    </FormItem>;
  };

  const renderAccessFields = () => {
    return <div className={classes.boxFields}>
      <div className={classes.flexRow}>
        {renderAccessType()}
        {renderWatchers()}
      </div>
      <div className={classes.flexRow}>
        {renderTeamField()}
      </div>
    </div>;
  };

  const renderAccess = () => {
    return <div className={classes.box}>
      {renderAccessTitle()}
      {renderAccessFields()}
    </div>;
  };

  const renderContentTitle = () => {
    return <div className={classes.boxTitle}>
      <div className={classes.boxIcon}>
        <ContentsIcon className={classes.boxIcon} />
      </div>
      <span>Contents</span>
    </div>;
  };

  const renderCargo = () => {
    const isRequired = formFieldConfig[CARGO.configKey] ?? CARGO.required;
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={getLabel(CARGO.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(CARGO.key, {
        rules: !isBlNumberPresent ? [rules] : undefined,
        initialValue: editData?.id ? editData[CARGO.key] : undefined,
      })(<SelectCargo
        placeholder={CARGO.placeholder}
        cargoTypes={cargoType}
        className={classes.input}
        disabled={editData?.cargoDisabled}
        onChange={() => {
          form.resetFields([SUB_CARGO.key]);
          if (editData?.id) {
            editData.cargoProduct = undefined;
          }
        }}
      />)}
    </FormItem>;
  };

  const renderSubCargo = () => {
    if (isRoadBased && cargoTypeValue !== 'REEFER') return null;
    const isRequired = formFieldConfig[SUB_CARGO.configKey] ?? SUB_CARGO.required;
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={getLabel(SUB_CARGO.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(SUB_CARGO.key, {
        rules: !isBlNumberPresent ? [rules] : undefined,
        initialValue: editData?.id ? editData[SUB_CARGO.key] : undefined,
      })(<SelectProductType
        disabled={editData?.cargoDisabled}
        placeholder={SUB_CARGO.placeholder}
        className={classes.input}
        cargoSubTypes={validCargoTypeToCargoSubtypeMapping}
        cargoType={cargoTypeValue || editData?.cargo}
      />)}
    </FormItem>;
  };

  const renderQuantity = (product: Product, idx: number) => {
    const isRequired = isRoadBased 
      ? false 
      : !isBlNumberPresent && (formFieldConfig[ProductFormFieldExtraKeys.PRODUCT_COUNT.configKey] ?? PRODUCT.required);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <div
      className={classes.productQuantity}
    >
      <FormItem
        className={classes.formItem}
      >
        {getFieldDecorator(`${PRODUCT.key}[${product.id}]['quantity']`, {
          initialValue: product?.quantity,
          rules: [{
            validator: (rule, val, cb) => {
              if (val < 0) {
                return cb('Quantity should be positive');
              }
              cb();
            },
          }, rules]
        })(<InputNumber
          min={0}
          disabled={isRoadBased ? false : editData?.productDisabled}
          type="number"
          style={{ width: 90 }}
          placeholder={isRequired ? "Count*" : "Count"}
        />)}
      </FormItem>
    </div>;
  };

  const renderUnitLabel = (label: string) => {
    return <div
      style={{ paddingRight: 30 }}
      className={classes.productLabel}
    >
      {label}
    </div>;
  };

  const renderUnitTypeOptions = () => {
    const options =  [
      <Select.OptGroup
        label={renderUnitLabel('Weight')}
      >
        {validWeightUnits?.map(item => 
        {
          // Skipping "cases" unit as it is required only in containerUnits
          if (EXCLUDED_WEIGHT_UNITS.includes(item)) {
            return null;
          } else {
            return (
              <Select.Option key={item} value={item}>{item}</Select.Option>
            );
          }
        })}
      </Select.OptGroup>,
      <Select.OptGroup
        label={renderUnitLabel('Volume')}
      >
        {validVolumeUnits?.map(item => <Select.Option
          key={item}
        >
          {item}
        </Select.Option>)}
      </Select.OptGroup>,
    ];

    options.push(...validOtherUnits?.map(item => <Select.Option
      key={item}
    >
      {renderUnitLabel(prettifyString(item))}
    </Select.Option>))

    return options;
  };

  const renderUnit = (product: Product, idx: number) => {
    const isRequired = isRoadBased 
      ? false 
      : !isBlNumberPresent && (formFieldConfig[ProductFormFieldExtraKeys.PRODUCT_UNIT.configKey] ?? PRODUCT.required);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <div
      className={classes.productUnit}
    >
      <FormItem className={classes.formItem}>
        {getFieldDecorator(`${PRODUCT.key}[${product.id}]['unit']`, {
          initialValue: product?.unit ? product?.unit : undefined,
          rules: [rules]
        })(<Select
          allowClear
          style={{ width: 90 }}
          dropdownMatchSelectWidth={false}
          disabled={isRoadBased ? false : editData?.productDisabled}
          placeholder={isRequired ? 'Unit*' : 'Unit'}
        >
          {renderUnitTypeOptions()}
        </Select>
        )}
      </FormItem>
    </div>;
  };

  const renderCases = (product: Product, idx: number) => {
    if (isRoadBased) return null;
    const isRequired = !isBlNumberPresent && (formFieldConfig[ProductFormFieldExtraKeys.PRODUCT_CASES.configKey] ?? PRODUCT.required);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <div className={classes.productUnit}>
      <FormItem className={classes.formItem}>
        {getFieldDecorator(`${PRODUCT.key}[${product.id}]['cases']`, {
          initialValue: product?.cases,
          rules: [rules]
        })(<Input
          disabled={editData?.productDisabled}
          style={{ width: 90 }}
          placeholder={isRequired ? "Cases*" : "Cases"}
        />
        )}
      </FormItem>
    </div>;
  };

  const renderSkuClientNumber = (product: Product, idx: number) => {
    if (isRoadBased) return null;
    const isRequired = !isBlNumberPresent && (formFieldConfig[ProductFormFieldExtraKeys.PRODUCT_SKU.configKey] ?? PRODUCT.required);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <div className={classes.productUnit}>
      <FormItem className={classes.formItem}>
        {getFieldDecorator(`${PRODUCT.key}[${product.id}]['skuClientNumber']`, {
          initialValue: product?.skuClientNumber,
          rules: [rules]
        })(<Input
          disabled={editData?.productDisabled}
          style={{ width: 90 }}
          placeholder={isRequired ? "SKU*" : "SKU"} />
        )}
      </FormItem>
    </div>;
  };

  const renderProduct = (product: Product, idx: number) => {
    const isRequired = isRoadBased 
      ? true 
      : !isBlNumberPresent && (formFieldConfig[ProductFormFieldExtraKeys.PRODUCT_NAME.configKey] ?? PRODUCT.required);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <div
      className={classes.productSelect}
    >
      <FormItem
        label={''}
        className={classes.formItem}
      >
        {getFieldDecorator(`${PRODUCT.key}[${product.id}]['key']`, {
          initialValue: product?.key ? {
            key: product.key,
            label: product.internalName,
          } : undefined,
          rules: [rules]
        })(<SelectProducts
          style={{ width: 250 }}
          placeholder={isRequired ? PRODUCT.placeholder + '*' : PRODUCT.placeholder}
          disabled={isFieldDiabled(PRODUCT.disableKey)}
        />)}
      </FormItem>
    </div>;
  };

  function handleAddMore(key: string) {
    if (key === CONTAINER.key) {
      setContainers([...containerList, { id: uuid() }]);
    } else {
      setProducts([...productsList, { id: uuid() }]);
    }
  };

  const renderAddMore = (field: FormField) => {
    if (isRoadBased) return null;
    const disabled = isFieldDiabled(field?.disableKey);

    if (disabled) {
      return;
    }

    const label = modeOfService !== ModesOfService.FCL && field !== PRODUCT ? 'Add More Package' : field.addMoreLabel;
    
    return <a
      style={{
        marginTop: -10,
        marginLeft: field === PRODUCT ? '15%' : '0%',
        cursor: disabled ? 'not-allowed' : 'pointer',
        color: disabled ? 'grey' : '#1890FF',
        width: '100%',
      }}
      onClick={() => handleAddMore(field.key)}
    >
      <Icon
        type="plus"
      />
      {label}
    </a>;
  };

  const renderProductLabel = (idx: number, label?: string) => {
    return <div className={classes.productLabel}>
      {idx > 0 ? null : getLabel(label || 'Products', false)}
    </div>;
  };

  function handleRemove(id: string, key: string) {
    if (key === CONTAINER.key) {
      const packagingDetails = form.getFieldValue('packagingDetails');
      delete packagingDetails?.[id];

      form.setFieldsValue({
        packagingDetails,
      });

      setContainers([...containerList?.filter(container => container.id !== id)])
    } else {
      const productDetails = form.getFieldValue('productDetails');
      delete productDetails?.[id];

      form.setFieldsValue({
        productDetails,
      });

      setProducts([...productsList?.filter(product => product.id !== id)]);
    }
  }

  const renderRemoveProduct = (product: Product, idx: number) => {
    if (productsList?.length === 1) return null;
    return (
      <Icon
        type="delete"
        onClick={() => handleRemove(product.id, PRODUCT.key)}
        className={classes.productCross}
      />
    );
  };

  const renderProductList = () => {
    return <div className={classes.flexColumn}>
      {productsList?.length > 0 && (
        <div className={classes.flexRow} style={{ justifyContent: 'flex-start', marginBottom: 4 }}>
          <div className={classes.productLabel} />
          <div style={{ width: 250, marginRight: 8, fontSize: 12, color: '#262626' }}>Name</div>
          <div style={{ width: 90, marginRight: 8, fontSize: 12, color: '#262626' }}>Count/Wt./Vol.</div>
          <div style={{ width: 90, marginRight: 8, fontSize: 12, color: '#262626' }}>Unit</div>
        </div>
      )}
      {productsList?.map((product, index) => <div
        key={product.id}
        className={classes.flexRow}
        style={{ justifyContent: 'flex-start' }}
      >
        {renderProductLabel(index)}
        {renderProduct(product, index)}
        {renderQuantity(product, index)}
        {renderUnit(product, index)}
        {allowCases ? renderCases(product, index) : null}
        {allowSkuNumber ? renderSkuClientNumber(product, index) : null}
        {renderRemoveProduct(product, index)}
      </div>)}
    </div>;
  };

  const renderStackableOption = () => {
    const isRequired = !isBlNumberPresent && (formFieldConfig[STACKABLE.configKey] ?? STACKABLE.required);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={getLabel(STACKABLE.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(STACKABLE.key, {
        rules: [rules],
        initialValue: editData?.id ? editData[STACKABLE.key] : undefined,
      })(
        <Radio.Group disabled={isFieldDiabled('stackableDisabled')}>
          <Radio value={true}>Yes</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      )}
    </FormItem>;
  }

const renderContentsFields = () => {
    return <div className={classes.boxFields}>
      <div className={classes.flexRow}>
        {renderCargo()}
        {renderSubCargo()}
      </div>
      {(modeOfService !== ModesOfService.FCL && !isRoadBased) && (
        <div className={classes.flexRow}>
          {renderStackableOption()}
        </div>
      )}
      { (props.stakeholderAccountType !== StakeholderTypes.CUSTOMER) && (
        <>
          {renderProductList()}
          {!isRoadBased && renderAddMore(PRODUCT)}
        </>
      )}
    </div>;
  };

  const renderContents = () => {
    return <div className={classes.box}>
      {renderContentTitle()}
      {renderContentsFields()}
    </div>;
  };

  const renderContainerTitle = () => {
    let title = 'Package';
    if (modeOfService === ModesOfService.DOMESTIC) title = 'Vehicle';
    if (modeOfService === ModesOfService.FCL) title = 'Container';
    return <div className={classes.boxTitle}>
      <div className={classes.boxIcon}>
        <ContainerIcon className={classes.boxIcon} />
      </div>
      <span>{title} Details</span>
    </div>;
  };

  const renderContainerDimensionUnit = (item: Container, config: fieldConfig) => {
    const { key, width, required } = config;
    const dimensionUnitDisabled = Boolean(editData?.containerDisabled && item?.dimensionUnit);
    const rules = {...formRules.required};
    rules.required = required
    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['dimensionUnit']`, {
        rules: [rules],
        initialValue: item?.dimensionUnit ?? item?.packageDimension?.unit,
      })(<Select
        allowClear
        placeholder={'Unit'}
        disabled={dimensionUnitDisabled}
        className={classes.containerFieldsSmall}
        onChange={() => onDimensionChange(item)}
        style={{ width }}
      >
        {validDimensionUnits.map(dimension => <Select.Option
          key={dimension}>
          {dimension}
        </Select.Option>)}
      </Select>)}
    </FormItem>;
  }

  const renderContainerMinVolumeUnit = (item: Container, config: fieldConfig) => {
    const { width } = config;
    const minVolumeUnitDisabled = Boolean(editData?.containerDisabled && item?.minVolumeUnit);
    const rules = {...formRules.required};
    rules.required = config.required
    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['minVolumeUnit']`, {
        rules: [rules],
        initialValue: item?.minVolumeUnit ?? item?.volume?.unit,
      })(<Select
        allowClear
        placeholder={'Unit'}
        disabled={minVolumeUnitDisabled}
        className={classes.containerFieldsSmall}
        onChange={(val) => onDimensionChange(item)}
        style={{ width }}
      >
        {validVolumeUnits.map(weight => <Select.Option
          key={weight}>
          {weight}
        </Select.Option>)}
      </Select>)}
    </FormItem>;
  }

  const renderContainerHeader = () => {
    return <div
      className={classes.flexRow}
      style={{ justifyContent: 'flex-start' }}
    >
      {packageDetailsToShow.map(config => {
        if (!config) return <></>;
        const required = typeof config.required === 'boolean' ? config.required : true;
        return (
          <div style={{ width: config.width }}>
            {getLabel(config.label, required)}
          </div>
        );
      })}
      <span style={{ width: 45 }} />
    </div>;
  };

  const shouldShowOtherPackagingDetails = (item: Container) => {
  const packagingDetails = form.getFieldValue(CONTAINER.key);
  return packagingDetails?.[item.id]?.type === 'OTHER';
};

  const renderOtherPackagingDetails = (item: Container, config: fieldConfig) => {
    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['otherType']`, {
        rules: [formRules.required],
        initialValue: item?.otherType,
      })(<Input
        placeholder={'Other Packaging Details'}
        style={{ minWidth: 'fit-content' }}
      />)}
    </FormItem>;
  };


  const renderContainerType = (item: Container, config: fieldConfig) => {
    const containerTypeDisabled = Boolean(editData?.containerDisabled && item?.type)
    let validList = (validContainerOrPackageTypesBasedOnMode[lookupMode || ModesOfService.FCL]) || {};
    if (modeOfService === ModesOfService.DOMESTIC) {
      validList = {};
      domesticVehicleTypeSizeList.forEach(item => {
        if (item.canUse) {
          validList[item.key.type] = item.label.type;
        }
      });
    }
    if (!modeOfService || modeOfService === ModesOfService.FCL) {
      const cargoType = form.getFieldValue(CARGO.key) || editData?.cargo;
      if (cargoType) {
        const newValidList = {};
        validContainerTypesForCargoFCL[cargoType].forEach(type => {
          if (type in validList) {
            newValidList[type] = validList[type];
          }
        });
        validList = newValidList;
      }
    }
    // const isRequired = config.required;
    const rules = {...formRules.required};
    rules.required = config.required;
    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
      
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['type']`, {
        rules: !isBlNumberPresent ? [rules] : undefined,
        initialValue: item?.type,
      })(<Select
        allowClear
        placeholder={'Type'}
        className={modeOfService === ModesOfService.FCL ? classes.containerFieldsLarge : classes.containerFields}
        disabled={containerTypeDisabled}
        onChange={(e) => {
          setSelectedContainerType(e);
        }}
      >
        {Object.keys(validList).map(container => <Select.Option
          key={container}>
          {validList[container]}
        </Select.Option>)}
      </Select>)}
    </FormItem>;
  };

  const renderContainerSize = (item: Container, config: fieldConfig) => {
    const containerSizeDisabled = Boolean(editData?.containerDisabled && item?.size);
    // const isRequired = !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_SIZE.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_SIZE.required);
    let validList = validContainerSizes;
    if (modeOfService === ModesOfService.DOMESTIC) {
      validList = [];
      domesticVehicleTypeSizeList.forEach(item => {
        if (item.canUse && validList.indexOf(item.key.size) === -1) {
          validList.push(item.key.size);
        }
      });
    }
    const rules = {...formRules.required};
    rules.required = config.required
    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['size']`, {
        rules: !isBlNumberPresent ? [rules] : undefined,
        initialValue: item?.size,
      })(<Select
        allowClear
        placeholder={'Size'}
        className={classes.containerFields}
        disabled={containerSizeDisabled}
      >
        {validList.map(container => <Select.Option
          key={container}>
          {container}
        </Select.Option>)}
      </Select>)}
    </FormItem>;
  };

  const renderTemperature = (item: Container, config: fieldConfig) => {
    const packagingDetails = form.getFieldsValue().packagingDetails[item.id];
    const isRefrigerated = packagingDetails?.type === 'REFRIGERATED';
    
    if (!isRefrigerated) {
      return <></>;
    }

    const temperatureDisabled = Boolean(editData?.containerDisabled && item?.temperature);
    const tempOptions = props.inquiryMaster.containerTemperatures;
    // const isRequired = !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TEMPERATURE.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_TEMPERATURE.required);
    const rules = {...formRules.required};
    rules.required = config.required

    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['temperature']`, {
        rules: !isBlNumberPresent ? [rules] : undefined,
        initialValue: item?.temperature,
      })(<Select
        allowClear
        placeholder={'Temperature'}
        className={classes.containerFields}
        disabled={temperatureDisabled}
        dropdownMatchSelectWidth={false}
      >
        {tempOptions.map(container => <Select.Option
          key={container}>
          {container}
        </Select.Option>)}
      </Select>)}
    </FormItem>;
  };

  const getMinVolume = (item: Container) => {
    const packageDetail = form.getFieldValue(CONTAINER.key)?.[item.id];
    
    const length = packageDetail?.length;
    const breadth = packageDetail?.breadth;
    const height = packageDetail?.height;
    const dimensionUnit = packageDetail?.dimensionUnit;
    const minVolumeUnit = packageDetail?.minVolumeUnit;

    const conversionFactor =
      volumeConverterMap[dimensionUnit] && volumeConverterMap[dimensionUnit][minVolumeUnit];
    const newVol =
      length &&
      length > 0 &&
      breadth &&
      breadth > 0 &&
      height &&
      height > 0 &&
      conversionFactor
        ? length * breadth * height * conversionFactor
        : undefined;
    
    return newVol;
  }

  const onDimensionChange = (item: Container) => {
    setNewDimension({ item, toggle: !newDimension.toggle });
  }

  React.useEffect(() => {
    const item = newDimension.item;

    if (!item) {
      return;
    }

    const minVol = getMinVolume(item);
    if (minVol) {
      form.setFieldsValue({
        [`${CONTAINER.key}[${item.id}]['minVolume']`]: minVol,
      });
    }
  }, [newDimension.toggle]);

  const renderPackageIntegerInput = (item: Container, config: fieldConfig) => {
    const { key, width, required, label } = config;
    const pkgInputDisabled = Boolean(editData?.containerDisabled && item?.[key]);
    return (
      <FormItem
        label={''}
        className={classes.formItem}
        {...formItemLayout}
      >
        {getFieldDecorator(`${CONTAINER.key}[${item.id}]['${key}']`, {
          rules: !isBlNumberPresent && required ? [formRules.required] : undefined,
          initialValue: item?.[key] || item?.packageDimension?.[key],
        })(<InputNumber
          placeholder={label}
          min={0}
          className={classes.containerFields}
          style={{ width }}
          disabled={pkgInputDisabled}
          onChange={() => onDimensionChange(item)}
        />)}
      </FormItem>
    );
  }

  const onMinVolumeChange = (item: Container) => {
    form.setFieldsValue({
      [`${CONTAINER.key}[${item.id}]['length']`]: undefined,
      [`${CONTAINER.key}[${item.id}]['breadth']`]: undefined,
      [`${CONTAINER.key}[${item.id}]['height']`]: undefined,
    });
  }

  const renderPackageMinVolume = (item: Container, config: fieldConfig) => {
    const { key, width, required, label } = config;
    const pkgInputDisabled = Boolean(editData?.containerDisabled && item?.minVolume);
    const rules = {...formRules.required};
    rules.required = config.required
    return (
      <FormItem
        label={''}
        className={classes.formItem}
        {...formItemLayout}
      >
        {getFieldDecorator(`${CONTAINER.key}[${item.id}]['${key}']`, {
          rules: !isBlNumberPresent ? [rules] : undefined,
          initialValue: item?.minVolume ?? item?.volume?.value,
        })(<InputNumber
          placeholder={label}
          min={0}
          className={classes.containerFields}
          style={{ width, minWidth: '120px' }}
          disabled={pkgInputDisabled}
          onChange={() => onMinVolumeChange(item)}
        />)}
      </FormItem>
    );
  }

  const renderContainerCount = (item: Container, config: fieldConfig) => {
    const containerCountDisabled = Boolean(editData?.containerDisabled && item?.count);
    // const isRequired = !isBlNumberPresent && config.required;
    const rules = {...formRules.required};
    const { width } = config;
    rules.required = config.required
    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['count']`, {
        rules: !isBlNumberPresent ? [rules] : undefined,
        initialValue: item?.count,
      })(<InputNumber
        placeholder={'Count'}
        min={0}
        style={{ width }}
        className={classes.containerFields}
        disabled={containerCountDisabled}
      />)}
    </FormItem>;
  };

  const renderContainerWeight = (item: Container, config: fieldConfig) => {
    const containerWeightDisabled = Boolean(editData?.containerDisabled && item?.totalWeight);
    // const isRequired = !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT.required);
    const rules = {...formRules.required};
    rules.required = config.required
    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['totalWeight']`, {
        initialValue: item?.totalWeight,
        rules: !isBlNumberPresent ? [rules] : undefined
      })(<InputNumber
        placeholder={'Weight'}
        className={classes.containerFields}
      />)}
    </FormItem>;
  };

  const renderContainerGrossWeight = (item: Container, config: fieldConfig) => {
    const containerWeightDisabled = Boolean(editData?.containerDisabled && item?.totalWeight);
    // const isRequired = !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_GROSS_WEIGHT.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_GROSS_WEIGHT.required);
    const rules = {...formRules.required};
    rules.required = config.required
    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['totalWeight']`, {
        rules: !isBlNumberPresent ? [rules] : undefined,
        initialValue: item?.grossWeight || item?.totalWeight,
      })(<InputNumber
        // disabled={containerWeightDisabled}
        placeholder={'Weight'}
        className={classes.containerFields}
      />)}
    </FormItem>;
  };

  const getTotalGrossWeight = (item: Container) => {
    const packagingDetails = form.getFieldsValue().packagingDetails[item.id];
  
    const grossWeight = (packagingDetails?.totalWeight);
    const quantity = (packagingDetails?.count);
    const unit = (packagingDetails?.totalWeightUnit);
    return (grossWeight || grossWeight === 0) && quantity && unit
      ? !!disableGrossWeightCalculation ? `${(grossWeight && grossWeight.toFixed(2))} ${unit}` : `${(grossWeight && (grossWeight * quantity).toFixed(2))} ${unit}`
      : '-';
  };

  const getTotalVolumetricWeight = (item: Container) => {
    const packagingDetails = form.getFieldsValue().packagingDetails[item.id];
  
    const length = packagingDetails?.length;
    const breadth = packagingDetails?.breadth;
    const height = packagingDetails?.height;
    const count = packagingDetails?.count;
    const lengthUnit = packagingDetails?.dimensionUnit;
    const volumeUnit = 'cbm';

    const conversionFactor =
      volumeConverterMap?.[lengthUnit] &&
      volumeConverterMap[lengthUnit][volumeUnit] &&
      volumeConverterMap[lengthUnit][volumeUnit];
    const newVol =
      length &&
      length > 0 &&
      breadth &&
      breadth > 0 &&
      height &&
      height > 0 &&
      conversionFactor
        ? length * breadth * height * conversionFactor
        : undefined;
    const volWeight = newVol
      ? +((newVol * 1000000) / VOLUMETRIC_WT_DENOMINATOR).toFixed(2)
      : undefined;
    return (volWeight || volWeight === 0) && count ? +(volWeight * count).toFixed(2) + 'kg' : '-';
  };

  const renderTotalGrossWeight = (item: Container) => {
    return <div className={classes.textValue}>{getTotalGrossWeight(item)}</div>;
  };

  const renderTotalVolumetricWeight = (item: Container) => {
    return <div className={classes.textValue}>{getTotalVolumetricWeight(item)}</div>;
  };

  const renderContainerWeightUnit = (item: Container, config: fieldConfig) => {
    const containerWeightUnit = Boolean(editData?.containerDisabled && item?.totalWeightUnit);
    // const isRequired = !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT_UNIT.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT_UNIT.required);
    const rules = {...formRules.required};
    rules.required = config.required
    return <FormItem
      label={''}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(`${CONTAINER.key}[${item.id}]['totalWeightUnit']`, {
        initialValue: item?.totalWeightUnit || undefined,
        rules: !isBlNumberPresent ? [rules] : undefined
      })(<Select
        allowClear
        placeholder={'Unit'}
        disabled={containerWeightUnit}
        className={classes.containerFieldsSmall}
      >
        {validWeightUnits.map(weight => <Select.Option
          key={weight}>
          {weight}
        </Select.Option>
      )}
      </Select>)}
    </FormItem>;
  };

  const renderRemoveContainer = (container: Container, idx: number) => {
    if (containerList?.length === 1 || editData.containerDisabled) {
      return <div style={{ width: 24 }} />;
    }

    return (
      <Icon
        type="delete"
        onClick={() => handleRemove(container.id, CONTAINER.key)}
        className={classes.productCross}
        style={{ marginLeft: 0 }}
      />
    );
  }
const renderContainerList = () => {
  return containerList?.map((item, idx) => {
    return (
      <div key={item.id}>
        <div
          className={classes.flexRow}
          style={{ justifyContent: 'flex-start' }}
        >
          {packageDetailsToShow?.map((config) => {
            if (!config || config.key === 'otherType') return <></>;
            return (
              <div key={config.key} style={{ width: config.width }}>
                {config.func(
                  item,
                  config as fieldConfig,
                )}
              </div>
            );
          })}
          {renderRemoveContainer(item, idx)}
        </div>
        {shouldShowOtherPackagingDetails(item) && (
          
            <div>
              {ContainerFields.otherType.func(
                item,
                {
                  ...ContainerFields.otherType,
                  width: '10em' 
                } as fieldConfig
              )}
            </div>
        )}
        {renderOutOfGaugeField(item)}
      </div>
    );
  });
};

  const renderNumberField = (fieldKey: string, required: boolean, initialValue: any, placeholder: string) => {
    const numberFieldDisabled = Boolean(editData?.containerDisabled && initialValue) || !required;

    return (
      <FormItem
        label={''}
        {...formItemLayout}
      >
        {getFieldDecorator(fieldKey, {
          initialValue: editData ? initialValue : undefined,
          rules: [{ required, message: 'Required' }]
        })(
          <InputNumber
            size="small"
            disabled={numberFieldDisabled}
            placeholder={`${placeholder} ${required ? '*' : ''}`}
          />
        )}
      </FormItem>
    )
  }

  const renderOutOfGaugeField = (item: any) => {
    if (isRoadBased) return null;
    const itemId = item.id;
    const fieldKey = `${CONTAINER?.key}[${itemId}]`;
    const packagingDetails = form.getFieldValue(CONTAINER?.key);
    const fieldValue = packagingDetails?.[itemId];
    const isChecked = editData?.id && item?.outOfGauge;
    const enableFields = fieldValue?.outOfGauge;

    if (['OPEN_TOP', 'FLAT_RACK'].includes(fieldValue?.type)) {
      const outOfGaugeField = (
        <div className={classes.formItemGauge}>
          <FormItem
            label={''}
            {...formItemLayout}
          >
            {getFieldDecorator(`${fieldKey}['outOfGauge']`, {
              initialValue: item?.outOfGauge
            })(<Checkbox key={itemId} defaultChecked={item?.outOfGauge}
            >
              Out of Gauge Cargo
            </Checkbox>)}
          </FormItem>
          {renderNumberField(`${fieldKey}['length']`, enableFields, item?.length, 'Length')}
          {renderNumberField(`${fieldKey}['breadth']`, enableFields, item?.breadth, 'Breadth')}
          {renderNumberField(`${fieldKey}['height']`, enableFields, item?.height, 'Height')}
          <FormItem
            label={''}
            {...formItemLayout}
          >
            {getFieldDecorator(`${fieldKey}['dimensionUnit']`, {
              initialValue: editData?.id ? item?.dimensionUnit : undefined,
              rules: [{ required: enableFields, message: 'Required' }]
            })(
              <Select
                allowClear
                placeholder={`Unit ${enableFields ? '*' : ''}`}
                size="small"
                style={{ width: '85px' }}
                disabled={editData?.containerDisabled || !enableFields}
              >
                {validDimensionUnits.map(dimension => <Select.Option
                  key={dimension}>
                  {dimension}
                </Select.Option>)}
              </Select>
            )}
          </FormItem>

        </div>
      )
      return outOfGaugeField;
    }
    return null;
  }

  const renderContainerField = () => {
    return <div className={classes.boxFields}>
      {renderContainerHeader()}
      {renderContainerList()}
      {renderAddMore(CONTAINER)}
    </div>;
  };

  const renderContainers = () => {
    return <div className={classes.box}>
      {renderContainerTitle()}
      {renderContainerField()}
    </div>;
  };

  const ContainerFields: Record<string, ContainerField> = {
    containerType: {
      label: 'Type',
      func: renderContainerType,
      key: 'type',
      width: modeOfService === ModesOfService.FCL ? '24%' : '15%',
      required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TYPE.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_TYPE.required)
    },
    otherType: {
      label: 'Other Type Details',
      func: renderOtherPackagingDetails,
      key: 'otherType',
      width: '75%',
      required: false
    },
    containerCount: {
      label: 'Count',
      func: renderContainerCount,
      key: 'count',
      width: '8%',
      required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_COUNT.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_COUNT.required)
    },
    packageLength: {
      label: 'Length',
      func: renderPackageIntegerInput,
      key: 'length',
      width: '8%',
      required: !isBlNumberPresent ? (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_LENGTH.configKey] ?? ![ModesOfService.LCL, ModesOfService.RPTL, ModesOfService.BREAK_BULK].includes(modeOfService)) : false,
    },
    packageBreadth: {
      label: 'Breadth',
      func: renderPackageIntegerInput,
      key: 'breadth',
      width: '8%',
      required: !isBlNumberPresent ? (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_BREADTH.configKey] ?? ![ModesOfService.LCL, ModesOfService.RPTL, ModesOfService.BREAK_BULK].includes(modeOfService)) : false,
    },
    packageHeight: {
      label: 'Height',
      func: renderPackageIntegerInput,
      key: 'height',
      width: '8%',
      required: !isBlNumberPresent ? (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_HEIGHT.configKey] ?? ![ModesOfService.LCL, ModesOfService.RPTL, ModesOfService.BREAK_BULK].includes(modeOfService)) : false,
    },
    containerDimensionUnit: {
      label: 'Unit',
      func: renderContainerDimensionUnit,
      width: '8%',
      required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_DIMENTION_UNIT.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_DIMENTION_UNIT.required)
    },
    packageMinVolume: {
      label: 'Min Volume',
      func: renderPackageMinVolume,
      key: 'minVolume',
      width: '15%',
      required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_MIN_VOL.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_MIN_VOL.required),
    },
    containerMinVolumeUnit: {
      label: 'Unit',
      func: renderContainerMinVolumeUnit,
      width: '8%',
      required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_MIN_VOL_UNIT.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_MIN_VOL_UNIT.required),
    },
    containerWeight: {
      label: 'Total Cargo Weight',
      func: renderContainerWeight,
      key: 'totalWeight',
      width: '15%',
      required: isRoadBased || (!isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT.required)),
    },
    grossWeight: {
      label: 'Gross Weight',
      func: renderContainerGrossWeight,
      key: 'totalWeight',
      width: '10%',
      required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_GROSS_WEIGHT.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_GROSS_WEIGHT.required)
    },
    containerWeightUnit: {
      label: 'Unit',
      func: renderContainerWeightUnit,
      key: 'totalWeightUnit',
      width: '8%',
      required: isRoadBased || (!isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT_UNIT.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT_UNIT.required))
    },
    containerSize: {
      label: 'Size',
      func: renderContainerSize,
      width: '15%',
      required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_SIZE.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_SIZE.required)
    },
    totalGrossWt: {
      label: 'Total Gross Weight',
      func: renderTotalGrossWeight,
      width: '15%',
      // required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TYPE.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_TYPE.required)
    },
    totalVolumetricWt: {
      label: 'Total Volumetric Weight',
      func: renderTotalVolumetricWeight,
      width: '10%',
      // required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TYPE.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_TYPE.required)
    },
    temperature: {
      label: 'Temperature',
      func: renderTemperature,
      key: 'temperature',
      width: '15%',
      required: !isBlNumberPresent && (formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TEMPERATURE.configKey] ?? ContainerFormFieldExtraKeys.CONTAINER_TEMPERATURE.required)
    },
  }

  React.useEffect(() => {
    const isRefrigeratedInInitialList =
      containerList?.some(item => !!(item.type === 'REFRIGERATED'));
    if (isRefrigeratedInInitialList) {
      setTemperatureField(ContainerFields?.temperature);
      return;
    }
    setTemperatureField(undefined);
  }, [containerList]);

  const showTemperature = () => {
    const packaging = form.getFieldValue(CONTAINER.key);
    const isRefrigerated = Object.keys(packaging || {}).some(item => !!(packaging[item]?.type === 'REFRIGERATED'));
    if (isRefrigerated) {
      return ContainerFields.temperature;
    }
    return;
  }

  // if (loading) {
  //   return <Loader />;
  // }

  return <div className={classes.main} style={{display: hide ? 'none' : 'block'}}>
    {renderPrimary()}
    {renderPort()}
    {renderContents()}
    {renderContainers()}
    {renderAccess()}
  </div>;
};

const options: HocOptions = {
  connectJss: {
    useJss: true,
    styleSheet: newShipmentFirstStyles,
  },
  ignoreWithAuth: true,
};

const StepOne = GenericHoc(options)(NewShipmentFirst);
export default StepOne;
